import Backbone from 'backbone';
import config from '../config/config.js';
import MenuGroupsView from '../view/menuGroupsView';
import MenuGroupsModel from '../models/menuGroups';

export default Backbone.View.extend({
  initialize(o) {
    var menuType = o.menu_type;
    this.menu = config.options[menuType];
    this.menuGroupsView = new MenuGroupsView({
      collection: new MenuGroupsModel(this.menu.groups)
    });
    this.render();
  },
  events: {
    'click .menu-heading .close_button': 'closeMenu'
  },
  template: function(list) {
    return `  
    <div class="simpleMenu">
        <div class="menu-wrapper">
          <div class="menu-heading"><div class="heading">${this.menu.name}</div><div class="close_button"><i class="fa fa-close"></i></div></div>      
        </div>
    </div>
    `;
  },

  closeMenu() {
    let button = editor.Panels.getButton('left-top-view', 'market_place_menu');
    button.set('active', false);
  },

  render() {
    this.isActive = true;
    this.$el.append(this.template());
    this.$el.find('.menu-wrapper').append(this.menuGroupsView.render().$el);
  }
});
